// src/components/FacebookFeed.js
import React, { useEffect } from 'react';
import './FacebookFeed.css';

function FacebookFeed() {
  useEffect(() => {
    // Fonction d'initialisation du SDK Facebook
    const initFacebookSDK = () => {
      // Vérifie si le SDK est déjà chargé
      if (window.FB) {
        window.FB.XFBML.parse(); // Re-parse les éléments XFBML si déjà chargé
        return;
      }

      // Initialisation du SDK Facebook
      window.fbAsyncInit = function() {
        window.FB.init({
          appId: 'YOUR_APP_ID', // Remplacez par votre ID d'application Facebook si vous en avez un, sinon laissez tel quel.
                               // Pour de simples embeds publics, ce n'est pas toujours nécessaire mais bonne pratique.
          cookie: true,
          xfbml: true, // Active le parsing des plugins sociaux (comme les embeds)
          version: 'v20.0' // Utilisez la dernière version de l'API (v20.0 est la plus récente en juin 2024)
        });
      };

      // Charge le SDK JavaScript de Facebook de manière asynchrène
      (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { return; }
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/fr_FR/sdk.js"; // Langue française
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    };

    initFacebookSDK(); // Appelle la fonction d'initialisation

  }, []);

  // L'URL de votre page Facebook
  // IMPORTANT : Remplacez cette URL par l'URL réelle de votre page Facebook !
  const facebookPageUrl = "https://www.facebook.com/votrepagefacebook"; 

  return (
    <section className="facebook-section">
      <h2 className="facebook-title">Retrouvez-nous sur Facebook !</h2>

      <div className="facebook-grid">
        {/* Publication 1 */}
        <div
          className="fb-post"
          data-href="https://www.facebook.com/photo?fbid=122242643954200315&set=a.122108534654200315"
          data-width="500"
          data-show-text="true"
          data-hide-cta="true"
        ></div>

        {/* Publication 2 */}
        <div
          className="fb-post"
          data-href="https://www.facebook.com/photo/?fbid=122218395548200315&set=a.122108534654200315"
          data-width="500"
          data-show-text="true"
          data-hide-cta="true"
        ></div>

        {/* Vous pouvez ajouter d'autres publications ici */}

      </div>

      {/* AJOUTÉ : Conteneur pour le bouton "Nous suivre sur Facebook" */}
      <div className="facebook-footer">
        <a
          href={facebookPageUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="cta-button"
        >
          Nous suivre sur Facebook
        </a>
      </div>
    </section>
  );
}

export default FacebookFeed;